import type { EstadoImpresora } from "../../lib/consola-api";

/**
 * La acción de estado que ofrece la fila (ADR 0081).
 *
 * Va aparte porque no falla: ofrecer la equivocada deja una máquina marcada
 * como disponible cuando está en el taller, y el worker acepta cualquier
 * estado sin chistar.
 */
export function accionDeEstado(
  estado: EstadoImpresora,
): { destino: EstadoImpresora; etiqueta: string } | null {
  // La condición de `imprenta`: si no está ya en mantenimiento, se puede
  // mandar. Incluso ocupada — una máquina se rompe con trabajo encima.
  if (estado !== "MAINTENANCE") return { destino: "MAINTENANCE", etiqueta: "A mantenimiento" };
  // De vuelta a disponible y no a ocupada: BUSY diría que está imprimiendo
  // algo que nadie le mandó.
  return { destino: "IDLE", etiqueta: "Disponible" };
}
